import Dashboard from "@material-ui/icons/Dashboard";
import Input from "@material-ui/icons/Input";
import People from "@material-ui/icons/People";
import ListAlt from "@material-ui/icons/ListAlt";
import TrendingUp from "@material-ui/icons/TrendingUp";

import DashboardPage from "views/Dashboard/Dashboard.js";
import UserProfile from "views/UserProfile/UserProfile.js";
import LogoutPage from "views/LoginPage/LogoutPage.jsx";
import CapturaIncidencia from "views/Invex/CapturaIncidencia";
import ReporteCapturaIncidencias from "views/Invex/ReporteCapturaIncidencias";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin",
    id: 1
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    icon: People,
    component: UserProfile,
    layout: "/admin",
    id: 6
  },
  {
    path: "/capturaincidencia",
    name: "Captura Incidencia",
    icon: ListAlt,
    component: CapturaIncidencia,
    layout: "/admin",
    id: 28
  },
  {
    path: "/reporteincidencia",
    name: "Reporte Incidencia",
    icon: TrendingUp,
    component: ReporteCapturaIncidencias,
    layout: "/admin",
    id: 29
  },
  {
    path: "/logout",
    name: "Cerrar Sesión",
    icon: Input,
    component: LogoutPage,
    layout: "/admin",
    id: 0
  }
];

export default dashboardRoutes;